import type { SVGProps } from 'react';
const SvgPagRightArrowTwo = (props: SVGProps<SVGSVGElement>) => (
  
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.77325 4L3.83325 4.94L6.88659 8L3.83325 11.06L4.77325 12L8.77325 8L4.77325 4Z"
      fill="black"
    />
    <path
      d="M9.16656 4L8.22656 4.94L11.2799 8L8.22656 11.06L9.16656 12L13.1666 8L9.16656 4Z"
      fill="black"
    />
  </svg>
);
export default SvgPagRightArrowTwo;
